<div class="close-button">
  <button mat-icon-button (click)="closeNotifications.emit()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div class="notification-panel">
  <div class="notification-header">
    <h2>{{ 'notificationsMessages' | translate }}</h2>
  </div>

  <div class="notification-list">
    @for (notification of notifications; track notification) {
      <div
        class="notification-item"
        [class.unread]="!notification.seen"
        (click)="openDialogMessage.emit(notification)">
        <div class="notification-content">
          <p class="font-bold">
            {{ notification.title }}
            <span class="time">{{ timeAgo(notification.time) }}</span>
          </p>
          <span>{{ notification.message }}</span>
        </div>
        <button
          class="self-start"
          mat-icon-button
          (click)="markAsRead.emit(notification.id)">
          <mat-icon>check_circle</mat-icon>
        </button>
      </div>
    }
    @if (!notifications.length) {
      <div class="py-[1rem] text-center">
        {{ 'noNotifications' | translate }}
      </div>
    }
  </div>
  <div class="flex py-2">
    @if (!!notifications.length) {
      <button class="w-full" mat-button (click)="markAllAsRead.emit()">
        {{ 'markAllAsRead' | translate }}
      </button>
    }
  </div>
</div>
